export * from "./config";
export * from "./keys";
export * from "./messages/ar";
export * from "./messages/en";

import { arMessages } from "./messages/ar";
import { enMessages } from "./messages/en";
import type { PortalLocale } from "./config";

export const messageCatalogs = {
  ar: arMessages,
  en: enMessages,
} as const satisfies Record<PortalLocale, typeof arMessages>;

export function getMessagesForLocale(locale: PortalLocale) {
  return messageCatalogs[locale];
}
